import { Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { Company } from "@/types";

interface CompanyAboutSidebarProps {
  company: Company;
}

export default function CompanyAboutSidebar({ company }: CompanyAboutSidebarProps) {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          mb: 2,
        }}
      >
        {t("company.about")}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 1,
        }}
      >
        <strong>OIB:</strong> {company.oib}
      </Typography>
      {company.emails.length > 0 && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 1,
          }}
        >
          <strong>Email:</strong> {company.emails.join(", ")}
        </Typography>
      )}
      {company.phones.length > 0 && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 1,
          }}
        >
          <strong>Tel:</strong> {company.phones.join(", ")}
        </Typography>
      )}
      {company.urls.length > 0 && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 1,
          }}
        >
          <strong>Web:</strong> {company.urls.join(", ")}
        </Typography>
      )}
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mt: 1,
        }}
      >
        <strong>{t("company.reviews")}:</strong> {company.reviewCount ?? 0}
      </Typography>
    </Paper>
  );
}
